import bowser from 'bowser';
import { get } from 'lodash';

import { initializeApp } from 'firebase/app';
import {
  getMessaging,
  getToken,
  onMessage,
  deleteToken,
} from 'firebase/messaging';
import config from '../../global/env.config';

const { firebaseConfig, vapidKey } = config;

export default angular
  .module('doxy.common.services.firebase', [])
  .factory('FirebaseMessaging', function (notificationFactory, User) {
    // Disable this feature for ios for now
    if (bowser.ios) {
      return {
        subscribe: () => null,
        unsubscribe: () => null,
      };
    }

    const tokenStorageKey = 'fcmMessagingToken';

    const app = initializeApp(firebaseConfig);
    const messaging = getMessaging(app);

    async function clearToken() {
      const storedToken = localStorage.getItem(tokenStorageKey);
      if (storedToken) {
        return deleteToken(messaging).then(() => {
          localStorage.removeItem(tokenStorageKey);
          return null; // to shut up eslint
        });
      }
      return null;
    }

    function createSubscription(token) {
      const user = User.getCachedCurrent();
      const institutionId = get(user, 'institutionMember.institutionId');

      return User.prototype$createPushSubscription(
        { id: user.id },
        {
          token,
          ...(Boolean(institutionId) && { institutionId }),
        }
      ).$promise.then(async () => {
        localStorage.setItem(tokenStorageKey, token);
        return null;
      });
    }

    return {
      initialized: false,

      async unsubscribe() {
        this.initialized = false;
        return clearToken();
      },

      async subscribe() {
        const user = User.getCachedCurrent();
        if (Boolean(user.browserNotifications) && !this.initialized) {
          onMessage(messaging, (payload) => {
            if (Date.now() > Number.parseInt(payload.data.expiredAt)) {
              return;
            }
            const notification = payload.notification;
            notificationFactory.show('generic', notification);
          });

          try {
            const permission = await Notification.requestPermission();
            if (permission !== 'granted') {
              throw new Error('Permission denied');
            }

            const newToken = await getToken(messaging, { vapidKey });
            const storedToken = localStorage.getItem(tokenStorageKey);
            const isTokenUpdate = storedToken !== newToken;

            if (isTokenUpdate) {
              await createSubscription(newToken);
            }
          } catch (err) {
            console.error('Firebase messaging error:', err);
          }

          this.initialized = true;
        }
      },
    };
  }).name;
